module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp3-01-01385119feb2b9d4b3b8d257b692cb24.png";